import { render, staticRenderFns } from "./ContrattoDiServizioNotes.vue?vue&type=template&id=0a8197da"
import script from "./ContrattoDiServizioNotes.vue?vue&type=script&lang=js"
export * from "./ContrattoDiServizioNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports